import styled, { keyframes, css } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.8); }
  to   { opacity: 1; transform: scale(1); }
`;

const pulse = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(2, 123, 192, 0.4); }
  70%  { box-shadow: 0 0 0 10px rgba(2, 123, 192, 0); }
  100% { box-shadow: 0 0 0 0 rgba(2, 123, 192, 0); }
`;

const bounce = keyframes`
  0%, 80%, 100% { transform: translateY(0); opacity: 0.3; }
  40%           { transform: translateY(-5px); opacity: 1; }
`;

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  width: 100%;
  max-width: ${({ $isTerminal }) => ($isTerminal ? "770px" : "360px")};
  margin: 0 auto;
`;

export const CirclesRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const LabelsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 8px;
`;

export const StepCircle = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.4s ease;
  position: relative;
  z-index: 2;

  ${({ $completado, $activo }) => {
    if ($completado) {
      return css`
        background-color: var(--color-broccoli);
        color: white;
        animation: ${fadeIn} 0.4s ease;
      `;
    }
    if ($activo) {
      return css`
        background-color: var(--color-latex30);
        color: white;
        animation: ${pulse} 1.5s ease infinite;
        outline: 10px solid white;
      `;
    }
    return css`
      background-color: var(--color-grey90);
      color: var(--color-grey65);
    `;
  }}
`;

export const StepIconCheck = styled.span`
  animation: ${fadeIn} 0.3s ease;
  font-size: 16px;
`;

export const StepLabel = styled.span`
  font-size: 11px;
  font-weight: ${({ $activo }) => ($activo ? "600" : "400")};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  text-align: center;
  width: 36px;
  flex-shrink: 0;
  transition: all 0.3s ease;

  ${({ $completado, $activo }) => {
    if ($completado) return `color: var(--color-broccoli);`;
    if ($activo) return `color: var(--color-latex30);`;
    return `color: var(--color-grey65);`;
  }}
`;

export const StepLine = styled.div`
  height: 3px;
  flex: 1;
  background-color: var(--color-grey90);
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background-color: var(--color-broccoli);
    transition: width 0.5s ease;
    width: ${({ $completado }) => ($completado ? "100%" : "0%")};
  }
`;

export const DotsContainer = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 2px;
`;

export const Dot = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: var(--color-latex30);
  animation: ${bounce} 1.2s ease-in-out infinite;
  animation-delay: ${({ $delay }) => $delay}s;
`;
